import { useTranslations } from '@/core/translation'
import { useMemo } from 'react'
import { MapProps } from '../Map.types'
import { MARKER_TYPE } from '../Marker'
import { CityCenterIcon, FlightIcon, HotelIcon, VenueIcon } from '@/assets'
import { UseGetDefaultMapPinsProps } from './useGetDefaultMapPins.types'

const useGetDefaultMapPins = ({ airport, cityCenter, venue, hotel }: UseGetDefaultMapPinsProps) => {
  const t = useTranslations('map')

  const pins: MapProps['locations'] = useMemo(() => {
    const mapLocations = []

    if (venue) {
      mapLocations.push({
        type: MARKER_TYPE.VENUE,
        key: venue.id,
        Icon: VenueIcon,
        label: t('venue'),
        location: { lat: venue.address.latitude, lng: venue.address.longitude },
      })
    }

    if (cityCenter) {
      mapLocations.push({
        type: MARKER_TYPE.CITY_CENTER,
        key: cityCenter.name,
        Icon: CityCenterIcon,
        label: t('cityCenter'),
        location: { lat: cityCenter.latitude, lng: cityCenter.longitude },
      })
    }

    if (airport) {
      mapLocations.push({
        type: MARKER_TYPE.AIRPORT,
        key: airport.name,
        Icon: FlightIcon,
        label: t('airport'),
        location: { lat: airport.latitude, lng: airport.longitude },
      })
    }

    if (hotel) {
      mapLocations.push({
        type: MARKER_TYPE.HOTEL,
        key: MARKER_TYPE.HOTEL,
        Icon: HotelIcon,
        label: t('hotel'),
        location: { lat: hotel.latitude, lng: hotel.longitude },
      })
    }

    return mapLocations
  }, [venue, cityCenter, airport, hotel, t])

  return { pins }
}

export default useGetDefaultMapPins
